import React from 'react';
import { graphql } from 'gatsby';

import { Post as PostType, PublicidadType } from '../types/types';
import SEO from '../components/utilities/SEO';

import PostTemplate from './layout-post';

type DataType = {
  data: {
    post: PostType;
  };
  pageContext: {
    id: string;
    publicidadPosts: { mobile: PublicidadType; desktop: PublicidadType };
    newsPosts: PostType[];
    podcastPosts: PostType[];
    gatsbyConfig: {
      basketConfig: string;
      carnavalConfig: string;
      playerCustomTitles: string;
    };
  };
};

const Post = ({
  data: { post },
  pageContext: { publicidadPosts, newsPosts, podcastPosts, gatsbyConfig },
}: DataType) => (
  <PostTemplate
    gatsbyConfig={gatsbyConfig}
    newsPosts={newsPosts}
    podcastPosts={podcastPosts}
    post={post}
    publicidadPosts={publicidadPosts}
  />
);

export default Post;

export const pageQuery = graphql`
  query BlogPostById(
    # these variables are passed in via createPage.pageContext in gatsby-node.js
    $id: String!
  ) {
    # selecting the current post by id
    post: wpPost(id: { eq: $id }) {
      id
      databaseId
      title
      date(locale: "es")
      slug
      content
      excerpt
      afc_post {
        audioDeLaNota {
          mediaItemUrl
        }
        nombreColumnista
        nombreFotografo
      }
      featuredImage {
        node {
          sourceUrl
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(width: 800)
            }
          }
        }
      }
      categories {
        nodes {
          name
          slug
          parentId
        }
      }
      tags {
        nodes {
          name
          slug
        }
      }
    }
  }
`;

export const Head = ({ data: { post } }: DataType) => (
  <SEO
    article
    description={post.excerpt.replace(/(<([^>]+)>)/gi, '').replace(/\[&hellip;\]/g, '...')}
    image={post.featuredImage ? post.featuredImage.node.sourceUrl : null}
    title={`${post.title} - M24`}
  />
);
